var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnjoyEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_2469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3388 3.66118C18.9779 1.30024 15.8389 0 12.5 0C9.16113 0 6.02207 1.30024 3.66118 3.66118C1.3002 6.02207 0 9.16113 0 12.5C0 15.8389 1.3002 18.9779 3.66118 21.3388C6.02207 23.6998 9.16113 25 12.5 25C15.8389 25 18.9779 23.6998 21.3388 21.3388C23.6998 18.9779 25 15.8389 25 12.5C25 9.16113 23.6998 6.02207 21.3388 3.66118ZM12.5 23.5119C6.42803 23.5119 1.48809 18.572 1.48809 12.5C1.48809 6.42803 6.42803 1.48809 12.5 1.48809C18.572 1.48809 23.5119 6.42803 23.5119 12.5C23.5119 18.572 18.572 23.5119 12.5 23.5119Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79601 9.199C8.5776 7.98049 6.59503 7.98059 5.37662 9.199C5.08605 9.48953 5.08605 9.96067 5.37662 10.2512C5.66725 10.5418 6.13839 10.5418 6.42892 10.2512C7.0672 9.61301 8.10568 9.61306 8.74386 10.2512C8.88917 10.3966 9.07955 10.4692 9.26993 10.4692C9.46032 10.4692 9.65079 10.3966 9.79601 10.2512C10.0866 9.96067 10.0866 9.48958 9.79601 9.199ZM19.6233 9.199C18.4048 7.98059 16.4223 7.98049 15.2039 9.199C14.9133 9.48953 14.9133 9.96067 15.2039 10.2512C15.4945 10.5418 15.9656 10.5418 16.2562 10.2512C16.8943 9.61301 17.9328 9.61296 18.5711 10.2512C18.7164 10.3966 18.9068 10.4692 19.0972 10.4692C19.2876 10.4692 19.478 10.3966 19.6233 10.2512C19.9138 9.96067 19.9138 9.48958 19.6233 9.199ZM19.0972 13.0456H5.9028C5.49186 13.0456 5.15875 13.3788 5.15875 13.7897C5.15875 17.8376 8.45206 21.1309 12.5 21.1309C16.548 21.1309 19.8413 17.8376 19.8413 13.7897C19.8413 13.3787 19.5082 13.0456 19.0972 13.0456ZM12.5 19.6428C9.52452 19.6428 7.06046 17.4113 6.69391 14.5337H18.3062C17.9396 17.4113 15.4755 19.6428 12.5 19.6428Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_2469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnjoyEmoji);
export default __webpack_public_path__ + "static/media/EnjoyEmoji.618ad19fcd7f9911114ee3141d5772eb.svg";
export { ForwardRef as ReactComponent };